import { CardBody } from '../text';

export const NavSubItem = function ({ name, to, onClick, picked }) {
  return (
    <li onClick={onClick} style={{ fontWeight: (picked) ? "bolder" : "normal" }} className="block px-4 py-2 hover:font-bold">
      <CardBody name={name} color="blue" />
    </li>
  );
};
